export const studentHeadCells = [
  {
    id: 'student_register_number',
    label: 'Reg ID',
    numeric: true,
    sortable: true,
  },
  { id: 'student_name', label: 'Name', sortable: true },
  { id: 'grades', label: 'Grade', sortable: false },
  { id: 'fatherName', label: 'FName', sortable: false },
  { id: 'fatherContact', label: 'FContact', sortable: false },
  { id: 'VanFacility', label: 'VanFacility', sortable: false },
  { id: 'studentFee', label: 'Exam Fee', sortable: false },
  { id: 'studentDiscount', label: 'Discount', sortable: false },
  { id: 'transportFee', label: 'Transport', sortable: false },
  { id: 'miscFee', label: 'Misc', sortable: false },
  { id: 'dueDateAmount', label: 'Due', sortable: false },
  { id: 'total', label: 'Total', sortable: false },
  // { id: 'feeStatus', label: 'Fee Status', sortable: false },
  // { id: 'balance', label: 'Balance', sortable: false },
  { id: 'status', label: 'Status', sortable: false },
  { id: '', label: '', sortable: false },
]

export const studentTransportHeadCells = [
  {
    id: 'student_id',
    label: 'Reg ID',
    numeric: true,
    sortable: false,
  },
  { id: 'student_name', label: 'Name', sortable: false },
  { id: 'grades', label: 'Grade', sortable: false },
  // { id: 'section_name', label: 'Section', sortable: false },
  { id: 'transport_fee_status', label: 'Fee Status', sortable: false },
  { id: 'student_transport_fee', label: 'Transport Fees', sortable: false },
  { id: 'paid_transport_fee', label: 'Paid Transport Fees', sortable: false },
  { id: 'van_number', label: 'Van Number', sortable: false },
  { id: '', label: '', sortable: false },
]

export const studentPresenceHeadCells = [
  {
    id: 'user_id',
    label: 'Reg ID',
    numeric: true,
    sortable: true,
  },
  { id: 'student_name', label: 'Name', sortable: true },
  // { id: 'feeStatus', label: 'Fee Status', sortable: false },
  // { id: 'balance', label: 'Balance', sortable: false },
  { id: 'attendance_type', label: 'Status', sortable: false },
  { id: '', label: '', sortable: false },
]
export const employeePresenceHeadCells = [
  {
    id: 'user_id',
    label: 'Reg ID',
    numeric: true,
    sortable: true,
  },
  { id: 'employee_name', label: 'Name', sortable: true },
  // { id: 'feeStatus', label: 'Fee Status', sortable: false },
  // { id: 'balance', label: 'Balance', sortable: false },
  { id: 'attendance_date', label: 'Date', sortable: false },
  { id: 'attendance_type', label: 'Status', sortable: false },
  { id: 'CONTACT NUMBER', label: 'CONTACT NUMBER' },
  { id: '', label: '', sortable: false },

  // { id: '', label: '', sortable: false },
]

export const subjectHeadCells = [
  { id: 'subject_name', label: 'Subject Name', sortable: true },
  { id: '', label: '', sortable: false },
]
export const employeeHeadCells = [
  {
    id: 'employee_id',
    label: 'ID',
    numeric: true,
    sortable: true,
  },
  { id: 'employee_name', label: 'EMPLOYEE NAME', sortable: true },
  { id: 'ROLE', label: 'ROLE', sortable: false },
  { id: 'STATUS', label: 'STATUS', sortable: false },
  { id: 'CONTACT NUMBER', label: 'CONTACT NUMBER' },
  { id: '', label: '', sortable: false },
]

export const schoolHeadCells = [
  {
    id: 'school_id',
    label: 'SCHOOL ID',
    numeric: true,
    sortable: true,
  },
  { id: 'school_name', label: 'SCHOOL NAME', sortable: true },
  { id: 'GRADES', label: 'GRADES', sortable: false },
  { id: 'STUDENTS', label: 'STUDENTS', sortable: false },
  { id: 'TEACHERS', label: 'TEACHERS', sortable: false },
  { id: '', label: '', sortable: false },
]

export const classHeadCells = [
  {
    id: 'grade_id',
    label: 'GRADE ID',
    numeric: true,
    sortable: true,
  },
  { id: 'grade', label: 'GRADE NAME', sortable: true },
  { id: 'sectionName', label: 'SECTIONS' },
  { id: 'exam_fee', label: 'Exam Fee', sortable: false },
  { id: 'tuition_fee', label: 'Tuition Fee', sortable: false },
  { id: '', label: '', sortable: false },
]

export const teacherHeadCells = [
  {
    id: 'employee_id',
    label: 'TEACHER ID',
    numeric: true,
    sortable: true,
  },
  { id: 'employee_name', label: 'TEACHER NAME', sortable: true },
  { id: 'salary', label: 'SALARY', sortable: false },
  { id: 'joiningDate', label: 'JOINING DATE', sortable: false },
  { id: 'grades', label: 'GRADE & CLASS', sortable: false },
  { id: 'contact', label: 'CONTACT', sortable: false },
  { id: 'status', label: 'STATUS', sortable: false },
  { id: '', label: '', sortable: false },
]

export const feesHeadCells = [
  {
    id: 'student_register_number',
    label: 'Reg ID',
    numeric: true,
    sortable: true,
  },
  { id: 'student_name', label: 'Student Name', sortable: true },
  { id: 'class', label: 'Class', sortable: false },
  { id: 'status', label: 'Status', sortable: false },
  { id: 'tuition_fee', label: 'Tuition Fee', sortable: false },
  { id: 'monthly_fee', label: 'Monthly Fee', sortable: false },
  { id: 'paid_amount', label: 'Paid Fee', sortable: false },
  { id: 'paid_exam_amount', label: 'Paid Exam Fee', sortable: false },
  { id: 'misc_fee', label: 'Miscellaneous Fee', sortable: false },
  { id: 'student_fee_discount', label: 'Discount', sortable: false },
  // { id: 'paid', label: 'Paid', sortable: false },
  // { id: 'fee_last_year_due', label: 'Last Year Due', sortable: true },
  // { id: 'amount', label: 'Total Amount', sortable: false },
  { id: 'fee_balance', label: 'Fee Balance', sortable: true },

  { id: '', label: '', sortable: false },
]

export const individualfeesHeadCells = [
  // {
  //   id: 'payment_id',
  //   label: 'Payment ID',
  //   numeric: true,
  //   sortable: true,
  // },
  {
    id: 'month',
    label: 'Month',
    // numeric: true,
    sortable: true,
  },
  // { id: 'student_name', label: 'Student Name', sortable: true },
  // { id: 'class', label: 'Class', sortable: false },
  { id: 'month_fees', label: 'Month fees', sortable: false },
  { id: 'status', label: 'Status', sortable: false },
  { id: 'amount', label: 'Misc Amount', sortable: false },
  { id: 'fee_balance', label: 'Balance', sortable: true },
  { id: 'fee_discount', label: 'Discount', sortable: false },
  { id: 'paid', label: 'Total Paid', sortable: false },
  { id: 'paid_exam_fee', label: 'Paid Exam Fee', sortable: false },
  { id: '', label: '', sortable: false },
]
export const individualStudentCells = [
  // {
  //   id: 'payment_id',
  //   label: 'Payment ID',
  //   numeric: true,
  //   sortable: true,
  // },
  {
    id: 'month',
    label: 'Month',
    // numeric: true,
    sortable: true,
  },
  // { id: 'student_name', label: 'Student Name', sortable: true },
  // { id: 'class', label: 'Class', sortable: false },
  { id: 'month_fees', label: 'Month fees', sortable: false },
  { id: 'status', label: 'Status', sortable: false },
  { id: 'amount', label: 'Misc Amount', sortable: false },
  { id: 'fee_balance', label: 'Balance', sortable: true },
  { id: 'fee_discount', label: 'Discount', sortable: false },
  { id: 'paid', label: 'Total Paid', sortable: false },
  { id: 'paid_exam_fee', label: 'Paid Exam Fee', sortable: false },
  // { id: '', label: '', sortable: false },
]
export const individualTeacherCells = [
  // {
  //   id: 'payment_id',
  //   label: 'Payment ID',
  //   numeric: true,
  //   sortable: true,
  // },
  {
    id: 'employee_salary',
    label: 'Salary',
    // numeric: true,
    sortable: false,
  },
  { id: 'salary_date', label: 'Salary Date', sortable: false },
  { id: 'paid_month', label: 'Paid Month', sortable: false },
  { id: 'paid_this_month', label: 'Paid This Month', sortable: false },
  { id: 'salary_status', label: 'Status', sortable: false },
  // { id: 'section_name', label: 'Section', sortable: false },
  // { id: '', label: '', sortable: false },
]

export const expensesHeadCells = [
  {
    id: 'expense_id',
    label: 'ID',
    numeric: true,
    sortable: true,
  },
  { id: 'expense_title', label: 'Title', sortable: true },
  { id: 'category', label: 'Category', sortable: false },
  { id: 'employee', label: 'Employee', sortable: false },
  { id: 'dateExpense', label: 'Date Expense', sortable: false },
  { id: 'desc', label: 'Description', sortable: false },
  { id: 'expense_amount', label: 'Amount', sortable: true },
  // { id: 'paidTo', label: 'PAID TO', sortable: false },
  { id: '', label: '', sortable: false },
]

export const routeHeadCells = [
  {
    id: 'route_id',
    label: 'ID',
    numeric: true,
    sortable: false,
  },
  { id: 'route', label: 'ROUTE', sortable: true },
  { id: 'area', label: 'Assigned To', sortable: false },
  { id: 'stops', label: 'No. of Stops', sortable: true },
  { id: 'students', label: 'No. of Students', sortable: false },
  { id: '', label: '', sortable: false },
]

export const vanDriverHeadCells = [
  {
    id: 'driver_id',
    label: 'ID',
    numeric: true,
    sortable: false,
  },
  { id: 'driver_first_name', label: 'DRIVER NAME', sortable: false },
  { id: 'contact', label: 'CONTACT', sortable: false },
  // { id: 'status', label: 'STATUS', sortable: true },
  { id: '', label: '', sortable: false },
]

export const vanListHeadCells = [
  {
    id: 'van_id',
    label: 'VAN NUMBER',
    numeric: true,
    sortable: false,
  },
  { id: 'driver_first_name', label: 'DRIVER NAME', sortable: false },
  { id: 'route', label: 'ROUTE', sortable: false },
  { id: 'size', label: 'SIZE', sortable: false },
  { id: 'contact', label: 'DRIVER CONTACT', sortable: false },
  { id: '', label: '', sortable: false },
]

export const CreditHeadCells = [
  {
    id: 'credit_id',
    label: '#',
    numeric: true,
    sortable: false,
  },
  { id: 'user_name', label: 'USER NAME', sortable: false },
  { id: 'role', label: 'Role', sortable: false },
  { id: 'creditassigned', label: 'Credit Assigned', sortable: false },
  { id: '', label: '', sortable: false },
]
export const HolidayHeadCells = [
  {
    id: 'holiday_id',
    label: '#',
    numeric: true,
    sortable: false,
  },
  { id: 'holiday_name', label: 'HOLIDAY NAME', sortable: false },
  { id: 'date', label: 'Date', sortable: false },
  // { id: 'status', label: 'Status', sortable: false },
  { id: '', label: '', sortable: false },
]

// Helper to create safe column ID from time range string
const safeColumnId = (range) =>
  range
    .toLowerCase()
    .replace(/[:\s]/g, '_')
    .replace(/-/g, '_to_')
    .replace(/[^a-z0-9_]/g, '')

// Function to generate dynamic headCells from timetable data
export const generateTeacherTimeTableHeadCells = (timetableData) => {
  if (!timetableData || !Array.isArray(timetableData) || timetableData.length === 0) {
    return [
      { id: 'teacher_name', numeric: false, disablePadding: true, label: 'Teacher Name' },
      // { id: 'teacher_id',   numeric: true,  disablePadding: false, label: 'Teacher ID' },
    ]
  }

  const timeSlotSet = new Set()

  timetableData.forEach((teacher) => {
    if (teacher.slots && Array.isArray(teacher.slots)) {
      teacher.slots.forEach((slot) => {
        if (slot.slot_start_timing && slot.slot_end_timing) {
          const range = `${slot.slot_start_timing} - ${slot.slot_end_timing}`
          timeSlotSet.add(range)
        }
      })
    }
  })

  // Sort time ranges as strings (lexicographical order – good enough for consistent AM/PM format)
  const timeRanges = Array.from(timeSlotSet).sort()

  const headCells = [
    // { id: 'teacher_id', numeric: true, disablePadding: false, label: 'Teacher ID' },
    { id: 'teacher_name', numeric: false, disablePadding: true, label: 'Teacher Name' },
  ]

  timeRanges.forEach((range) => {
    headCells.push({
      id: safeColumnId(range),
      numeric: false,
      disablePadding: false,
      label: range, // e.g. "8:00 AM - 8:30 AM"
    })
  })

  // Optional extra columns at the end
  // headCells.push(
  //   { id: 'grade',   numeric: false, disablePadding: false, label: 'Grade'   },
  //   { id: 'section', numeric: false, disablePadding: false, label: 'Section' }
  // );

  return headCells
}
export const generateGradeTimeTableHeadCells = (timetableData) => {
  if (!timetableData || !Array.isArray(timetableData) || timetableData.length === 0) {
    return [
      { id: 'grade', numeric: false, disablePadding: true, label: 'Teacher Name' },
      // { id: 'teacher_id',   numeric: true,  disablePadding: false, label: 'Teacher ID' },
    ]
  }

  const timeSlotSet = new Set()

  timetableData.forEach((teacher) => {
    if (teacher.slots && Array.isArray(teacher.slots)) {
      teacher.slots.forEach((slot) => {
        if (slot.slot_start_timing && slot.slot_end_timing) {
          const range = `${slot.slot_start_timing} - ${slot.slot_end_timing}`
          timeSlotSet.add(range)
        }
      })
    }
  })

  // Sort time ranges as strings (lexicographical order – good enough for consistent AM/PM format)
  const timeRanges = Array.from(timeSlotSet).sort()

  const headCells = [{ id: 'grade', numeric: false, disablePadding: true, label: 'Class' }]

  timeRanges.forEach((range) => {
    headCells.push({
      id: safeColumnId(range),
      numeric: false,
      disablePadding: false,
      label: range, // e.g. "8:00 AM - 8:30 AM"
    })
  })

  // Optional extra columns at the end
  // headCells.push(
  //   { id: 'grade',   numeric: false, disablePadding: false, label: 'Grade'   },
  //   { id: 'section', numeric: false, disablePadding: false, label: 'Section' }
  // );

  return headCells
}
